/* File generated by the cedar:generate:chooser-choices-vars-files command. DO NOT DIRECTLY EDIT THIS FILE */

export default Object.freeze({
	CLIMBING_ANGLED_WALL: { 
		name: "Angled Wall",
		id: 80
	},
	CLIMBING_BOOSTER_STEP: { 
		name: "Booster Step",
		id: 86
	},
	CLIMBING_CEDAR_STAIR: { 
		name: "Cedar Stairway",
		id: 79
	},
	CLIMBING_CHINNY_SHINNY: { 
		name: "Chinny Shinny",
		id: 91
	},
	CLIMBING_FIRE_POLE: { 
		name: "Fire Pole",
		id: 89
	},
	CLIMBING_KNOTTED_ROPE: { 
		name: "Knotted Rope",
		id: 90
	},
	CLIMBING_LITTLE_ANGLED_WALL: { 
		name: "Little Angled Wall",
		id: 81
	},
	CLIMBING_ROLLICKING_ROUND: { 
		name: "Rollicking Roundabout",
		id: 92
	},
	CLIMBING_ROPE_LADDER: { 
		name: "Rope Ladder",
		id: 88
	},
	CLIMBING_VERT_WALL: { 
		name: "Vertical Wall",
		id: 84
	},
	CLIMBING_WOOD_LADDER: { 
		name: "Wood Ladder",
		id: 87
	},
	CONNECTORS_BRIDGE: { 
		name: "Bridge",
		id: 29
	},
	CONNECTORS_DUAL_SWING_BEAM: { 
		name: "Dual Swing Beam",
		id: 25
	},
	CONNECTORS_MONKEY: { 
		name: "Monkey Bars",
		id: 27
	},
	CONNECTORS_SKY_BRIDGE: { 
		name: "Sky Bridge",
		id: 26
	},
	CONNECTORS_SWING_BEAM: { 
		name: "Swing Beam",
		id: 24
	},
	DOWNSTAIRS_CLUBHOUSE: { 
		name: "Clubhouse",
		id: 117
	},
	DOWNSTAIRS_FLOOR: { 
		name: "Floor",
		id: 116
	},
	DOWNSTAIRS_PICNIC_TABLE: { 
		name: "Picnic Table",
		id: 114
	},
	DOWNSTAIRS_SANDBOX: { 
		name: "Sandbox & Cover",
		id: 115
	},
	FENCES_COLOR: { 
		name: "Color",
		id: 127
	},
	FENCES_CUTOUT: { 
		name: "Cutout",
		id: 126
	},
	FENCES_PLAIN: { 
		name: "Natural",
		id: 125
	},
	MISCELLANEOUS_STAFF_PICKS: { 
		name: "Staff Picks",
		id: 14
	},
	ORIENTATION_FLIPPED: { 
		name: "Flipped",
		id: 130
	},
	ORIENTATION_ORIGINAL: { 
		name: "Original",
		id: 129
	},
	PRODUCT_LINES_ARCHITECT: { 
		name: "Architectural",
		id: 17
	},
	PRODUCT_LINES_CLASSIC: { 
		name: "Classic",
		id: 16
	},
	PRODUCT_LINES_RUSTIC: { 
		name: "Rustic",
		id: 15
	},
	ROOFS_COLOR: { 
		name: "Color",
		id: 128
	},
	ROOFS_CUTOUT_HEART: { 
		name: "Heart Cutouts",
		id: 122
	},
	ROOFS_CUTOUT_STAR: { 
		name: "Star Cutouts",
		id: 121
	},
	ROOFS_PLANK: { 
		name: "Plank",
		id: 119
	},
	ROOFS_SHINGLE: { 
		name: "Shingle",
		id: 120
	},
	ROOT_CLIMBING: { 
		name: "Climbing",
		id: 6
	},
	ROOT_CONNECTORS: { 
		name: "Connectors",
		id: 4
	},
	ROOT_DOWNSTAIRS: { 
		name: "Downstairs",
		id: 12
	},
	ROOT_FENCES: { 
		name: "Fences",
		id: 9
	},
	ROOT_MISCELLANEOUS: { 
		name: "Miscellaneous",
		id: 1
	},
	ROOT_PRODUCT_LINES: { 
		name: "Product Lines",
		id: 2
	},
	ROOT_ROOFS: { 
		name: "Roofs",
		id: 13
	},
	ROOT_SLIDES_RAMPS_MORE: { 
		name: "Slides, Ramps & More",
		id: 5
	},
	ROOT_STRUCTURES: { 
		name: "Structures",
		id: 3
	},
	ROOT_SWINGS: { 
		name: "Swings",
		id: 7
	},
	SLIDES_BIG_CEDAR: { 
		name: "Big Cedar Slide",
		id: 42
	},
	SLIDES_BIG_SLIDE: { 
		name: "Big Slide",
		id: 40
	},
	SLIDES_CEDAR: { 
		name: "Cedar Slide",
		id: 41
	},
	SLIDES_CROWS_NEST: { 
		name: "Crow's Nest",
		id: 47
	},
	SLIDES_LITTLE_CEDAR: { 
		name: "Little Cedar Slide",
		id: 43
	},
	SLIDES_LITTLE_RAMP: { 
		name: "Little Ramp",
		id: 46
	},
	SLIDES_RAMP: { 
		name: "Ramp",
		id: 45
	},
	SLIDES_ROPE_N_BUCKET: { 
		name: "Rope 'n Bucket",
		id: 106
	},
	SLIDES_SLIDE: { 
		name: "Slide",
		id: 39
	},
	SLIDES_SPIRAL: { 
		name: "Spiral Slide",
		id: 44
	},
	SLIDES_TURNING_BAR: { 
		name: "Turning Bar",
		id: 48
	},
	SLIDES_WAVE: { 
		name: "Wave Slide",
		id: 131
	},
	STRUCTURES_GZ: { 
		name: "Gazebo",
		id: 22
	},
	STRUCTURES_LG: { 
		name: "Large",
		id: 20
	},
	STRUCTURES_MD: { 
		name: "Medium",
		id: 19
	},
	STRUCTURES_PH: { 
		name: "Playhouse",
		id: 23
	},
	STRUCTURES_SM: { 
		name: "Small",
		id: 18
	},
	STRUCTURES_XL: { 
		name: "Extra Large",
		id: 21
	},
	SWINGS_BENCH: { 
		name: "Bench Swing",
		id: 101
	},
	SWINGS_BUOY: { 
		name: "Buoy Swing",
		id: 100
	},
	SWINGS_HORSE: { 
		name: "Horse Swing",
		id: 97
	},
	SWINGS_POLY: { 
		name: "Poly Swing",
		id: 94
	},
	SWINGS_SKATEBOARD: { 
		name: "Skateboard Swing",
		id: 98
	},
	SWINGS_SLING: { 
		name: "Sling Swing",
		id: 93
	},
	SWINGS_TIRE: { 
		name: "Tire Swing",
		id: 99
	},
	SWINGS_TODDLER: { 
		name: "Toddler Swing",
		id: 96
	},
	SWINGS_TRAPEZE: { 
		name: "Trapeze & Rings",
		id: 95
	},
})
